// react-google-maps/api documentation: https://web.archive.org/web/20230701010714/https://react-google-maps-api-docs.netlify.app/
import { GoogleMap, Polygon, useJsApiLoader } from '@react-google-maps/api';
import { useCallback, useState } from 'react';
import colors from '../ui/colors';

const API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '';

const containerStyle = {
  width: '100%',
  height: '360px',
  marginTop: '30px',
};

const center = {
  lat: 22.54992, lng: 0,
};

export const mapStyle: google.maps.MapTypeStyle[] = [
  {
    elementType: 'geometry',
    stylers: [{ color: colors.greige }], // Land is grey
  },
  {
    featureType: 'water',
    elementType: 'geometry',
    stylers: [{ color: colors.white }], // Oceans are pure white
  },
  {
    featureType: 'administrative.country',
    elementType: 'geometry.stroke',
    stylers: [
      { color: colors.white }, // Country borders are pure white
      { weight: 1 }, // Border thickness
    ],
  },
  {
    featureType: 'administrative.land_parcel',
    stylers: [{ visibility: 'off' }], // Remove dashed horizon line
  },
  {
    featureType: 'administrative.locality',
    stylers: [{ visibility: 'off' }], // Remove vertical grid lines
  },
  {
    featureType: 'administrative.neighborhood',
    stylers: [{ visibility: 'off' }], // Remove any neighborhood markers
  },
  {
    featureType: 'administrative',
    elementType: 'geometry.fill',
    stylers: [{ visibility: 'off' }],
  },
  {
    elementType: 'labels',
    stylers: [{ visibility: 'off' }], // Remove labels
  },
  {
    featureType: 'poi',
    stylers: [{ visibility: 'off' }], // Remove points of interest
  },
  {
    featureType: 'road',
    stylers: [{ visibility: 'off' }], // Remove roads
  },
  {
    featureType: 'transit',
    stylers: [{ visibility: 'off' }], // Remove transit features
  },
];

const mapBounds = {
  north: 85, // Northern limit
  south: -75, // Southern limit
  west: -180, // Western limit
  east: 180, // Eastern limit
};

type polygonPath = {
  lat: number
  lng: number
}[];

type regionPath = { region: polygonPath[], color?: string };

export const googleConfig = {
  id: undefined,
  googleMapsApiKey: API_KEY,
  libraries: ['places' as const],
};

const Map: React.FC<{ shadedRegions?: regionPath[] }> = ({ shadedRegions = [] }) => {
  const { isLoaded } = useJsApiLoader(googleConfig);

  const [map, setMap] = useState<google.maps.Map | null>(null);

  const onLoad = useCallback((map: google.maps.Map) => {
    setMap(map);
  }, []);

  const onUnmount = useCallback(() => {
    setMap(null);
  }, []);

  return isLoaded
    ? (
        <GoogleMap
          mapContainerStyle={containerStyle}
          center={center}
          zoom={1}
          onLoad={onLoad}
          onUnmount={onUnmount}
          options={{
            styles: mapStyle,
            maxZoom: 1,
            minZoom: 1,
            gestureHandling: 'none',
            disableDefaultUI: true,
            cameraControl: false,
            restriction: {
              latLngBounds: mapBounds,
              strictBounds: true,
            },
          }}
        >
          {/* Child components, such as markers, info windows, etc. */}
          {shadedRegions.map(({ color, region }, i) => (
            <Polygon
              // onLoad={onLoad}
              key={i}
              paths={region}
              options={{
                strokeOpacity: 0,
                strokeWeight: 0,
                fillColor: color || colors.chartreuse,
              }}
            />
          ))}

        </GoogleMap>
      )
    : <></>;
};

export default Map;
